import { render, staticRenderFns } from "./MetalTextCommemorativeLicensePlate.vue?vue&type=template&id=6c7913fc&scoped=true"
import script from "./MetalTextCommemorativeLicensePlate.vue?vue&type=script&lang=js"
export * from "./MetalTextCommemorativeLicensePlate.vue?vue&type=script&lang=js"
import style0 from "./MetalTextCommemorativeLicensePlate.vue?vue&type=style&index=0&id=6c7913fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7913fc",
  null
  
)

export default component.exports